export default "__VITE_ASSET__zq_7gFbo__"